class PausePlay {
    wrappers: NodeListOf<HTMLElement>;
    constructor() {
        this.init();
    }

    init() {
       
        this.wrappers = document.querySelectorAll('.full-width-grid .video-wrapper, .key-messaging .video-wrapper');

        this.wrappers.forEach(wrapper => {
          const video = wrapper.querySelector<HTMLVideoElement>('video');
        
          if (video) {
            const thumbnail = wrapper.querySelector<HTMLElement>('.video-thumbnail');

            // Hide thumbnail when video starts playing
            video.addEventListener('playing', () => {
              if (thumbnail) {
                thumbnail.classList.add('d-none');
              }
            }, { once: true });
          }
      
          const toggleButton = wrapper.querySelector<HTMLButtonElement>('.btn-play-pause');
          if (toggleButton) {
            toggleButton.addEventListener('click', () => {
                console.log('click');
              const video = wrapper.querySelector<HTMLVideoElement>('video');
              const label = wrapper.querySelector<HTMLElement>('.play-pause-label');
              const icon = wrapper.querySelector<HTMLElement>('ion-icon');
            
              if (!video) return;
            
              if (video.paused) {
                video.play();
                if (label) label.textContent = 'Pause';
                if (icon) icon.setAttribute('name', 'pause-circle-outline');
              } else {
                video.pause();
                if (label) label.textContent = 'Play';
                if (icon) icon.setAttribute('name', 'play-circle-outline');
              }
            });
          }
        });
    }

    
}

export default PausePlay;